import { CanActivateChildFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, of, switchMap, withLatestFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { RequestStatus } from '@aaa/emember/types';
import { MobileRenewActions } from '../../../store/mobile-renew';
import { getMembershipError, isMembershipRequestStatus } from '@aaa/emember/store-membership';
import { RequestErrorType } from '../../../store/generic-errors';

export const membershipFailed: CanActivateChildFn = () => {
  const store = inject(Store);

  return store.select(isMembershipRequestStatus).pipe(
    filter((status) => [RequestStatus.FAILED, RequestStatus.SUCCESS].includes(status)),
    switchMap((status) => of(status).pipe(withLatestFrom(store.select(getMembershipError)))),
    map(([status, error]) => {
      if (status === RequestStatus.FAILED && error) {
        if (error && error.type === RequestErrorType.MembershipCancelled) {
          store.dispatch(MobileRenewActions.navigateTo({ status: 'error', errorCode: 'membershipIsCanceled' }));
        } else if (error) {
          store.dispatch(MobileRenewActions.navigateTo({ status: 'error', errorCode: 'membershipLookUpError' }));
        }

        return false;
      }

      return true;
    }),
  );
};

export default membershipFailed;
